<template>
  <div class="upgrade-authorize" v-if="isShowUpgrade">
    <div class="upgrade-title">{{ $t('he_3_se_upgrade') }}</div>
    <div class="upgrade">
      <template v-for="(item, _index) in data" :key="_index">
        <div class="name">{{ item.name }} {{ $t('firmware_upgrade') }}</div>
        <div class="btn">
          <div class="upgrade-btn" @click="openUpgrade(item.id)">{{ $t('go_upgrade') }}</div>
          <div class="upgrade-btn" @click="upgradeClick">{{ $t('i_have_upgrade') }}</div>
        </div>
      </template>
    </div>
  </div>
</template>
<script lang="ts">
const isShowUpgrade = ref(false)
export { isShowUpgrade }
</script>
<script setup lang="ts">
import { ref } from 'vue'
import { openExternalLink } from '@/tool/utility'
import { isShowUpgradeBtn } from './root_upgrade.vue'
import { isShowAuthorize } from '../authorize/authorize.vue'

const data = [
  {
    name: 'HE3 SE',
    id: 45,
  },
]

const openUpgrade = (id: number) => {
  openExternalLink(`https://www.irok.cn/news/${id}`)
}
const upgradeClick = () => {
  isShowAuthorize.value = true
  isShowUpgrade.value = false
  isShowUpgradeBtn.value = true
}
</script>

<style scoped lang="less">
.upgrade-authorize {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.upgrade-title {
  font-size: 20px;
  color: #fff;
  margin-bottom: 24px;
}

.upgrade {
  width: 676px;
  height: 112px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--glass-ghost-bg);
  backdrop-filter: var(--glass-ghost-blur);
  border: 1px solid var(--glass-ghost-border);
  border-radius: var(--radius-l);
  padding: 0 30px;

  .name {
    font-size: 20px;
    font-weight: bold;
    color: #fff;
  }

  .btn {
    display: flex;
    justify-content: flex-end;
    margin-left: 40px;
    gap: 20px;

    .upgrade-btn {
      border-radius: var(--action-btn-radius);
      text-align: center;
      font-size: 16px;
      font-weight: 700;
      background-color: #fff;
      color: var(--brand-color-pure);
      padding: 12px 32px;
      cursor: pointer;
      box-shadow: var(--action-btn-shadow);
      transition: var(--transition-base);

      &:hover {
        transform: translateY(-2px);
        box-shadow: var(--action-btn-shadow-hover);
        filter: brightness(1.05);
      }

      &:active {
        transform: translateY(0);
      }

      &:nth-child(2) {
        background: var(--glass-ghost-bg);
        backdrop-filter: var(--glass-ghost-blur);
        border: 1px solid var(--glass-ghost-border);
        color: var(--action-btn-ghost-text);
        box-shadow: none;

        &:hover {
          background: var(--glass-ghost-hover-bg);
          border-color: var(--glass-ghost-hover-border);
          box-shadow: none;
        }
      }
    }
  }
}
</style>
